if (!customElements.get('custom-avis-infos')) {
    customElements.define('custom-avis-infos', class extends HTMLElement {
        constructor() {
            super();

            // get the product form
            this.selectAvisButtons = this.querySelectorAll('[data-select-avis]');

            // get the master avis infos container
            this.masterAvisInfosContainer = document.querySelector('custom-avis-infos');

            this.expoday = this.masterAvisInfosContainer.getAttribute('data-expoday');
            this.expohour = this.masterAvisInfosContainer.getAttribute('data-expohour');
            this.complexe = this.masterAvisInfosContainer.getAttribute('data-complexe');

            this.isBuyingValid = false;
            // this.isCondoleanceValid = false;

            this.avisTextDescription = document.querySelector('custom-avis-infos .metafield-multi_line_text_field');
            if (this.avisTextDescription) {
                this.parseDescriptionHtml();
            }
            // handle buying restriction
            this.handleBuyingRestriction();
        }

        connectedCallback() {
            // add event listener to the trigger submit button
            this.selectAvisButtons.forEach(button => {
                button.addEventListener('click', this.handleSelectAvis.bind(this));
            });
        }

        disconnectedCallback() {
            // remove event listener from the trigger submit button
            this.selectAvisButtons.forEach(button => {
                button.removeEventListener('click', this.handleSelectAvis.bind(this));
            });
        }

        parseDescriptionHtml() {
            // get the description html
            let description = this.avisTextDescription.innerHTML;

            // Get the inner HTML and split by <br> tags
            const parts = description.split(/<br\s*\/?>/).map(line => line.trim()).filter(line => line);

            // Replace the span's content with new p elements
            description = parts.map(line => `<p>${line}</p>`).join('');

            // identify any https:// or http:// links with a better regex that properly terminates at the end of the URL
            // This regex captures URLs that end with alphanumeric, period, slash, or common URL chars but stop at whitespace
            const urlRegex = /(https?:\/\/[\w\-\.\/?\&\=\#\%\+\~\:\;\@\!\,]+)/g;
            const links = description.match(urlRegex);

            if (links) {
                links.forEach(link => {
                    // Create a RegExp with the link that ensures it's replaced exactly, not as part of a larger string
                    const safeLinkRegex = new RegExp(link.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
                    description = description.replace(safeLinkRegex, `<a class="link tw-text-primary-500" href="${link}" target="_blank">${window?.themeVariables?.strings?.avisDescriptionHyperlinkText}</a>`);
                });
            }

            // update the description
            this.avisTextDescription.innerHTML = description;
        }


        handleBuyingRestriction() {
            // check if the buying is restricted
            if (this.expoday != null && this.expohour != null) {
                this.isBuyingValid = window.isAvisHasValidDate(this.expoday, this.expohour)
                                        && window.isAvisHasValidComplexe(this.complexe);
                // this.isCondoleanceValid = window.isWithin24HoursAfterExpo(this.expoday, this.expohour);
            } else {
                this.isBuyingValid = false;
                // this.isCondoleanceValid = false;
            }

            // handle display
            if (!this.isBuyingValid) {
                console.log('Buying is restricted');

                // add restricted class to avis box
                this.classList.add('isRestricted');
            }
            else {
                console.log('Buying is not restricted');
                // remove restricted class from avis box
                this.classList.remove('isRestricted');
            }

        }


        handleSelectAvis(event) {
            event.preventDefault();

            // Select avis from condoleance form
            if (this.masterAvisInfosContainer) {
                // console.log("- updateAvisGlobalContext -");
                const avisData = {
                    id: this.masterAvisInfosContainer.dataset.id,
                    contrat: this.masterAvisInfosContainer.dataset.contrat,
                    complexe: this.masterAvisInfosContainer.dataset.complexe,
                    image: this.masterAvisInfosContainer.dataset.image,
                    expoAddress: this.masterAvisInfosContainer.dataset.expoaddress,
                    expoDay: this.masterAvisInfosContainer.dataset.expoday,
                    expoHour: this.masterAvisInfosContainer.dataset.expohour,
                    dates: this.masterAvisInfosContainer.dataset.dates,
                    name: this.masterAvisInfosContainer.dataset.name
                };

                // set global context
                sessionStorage.setItem('avisDataProduct', JSON.stringify(avisData));

                // reload avis association by event
                document.dispatchEvent(new Event('avis:reload'), {
                    detail: avisData,
                    bubbles: true
                });
            }

            // Redirect to the condoleance form
            if (event.target.getAttribute('href')) {
                window.location.href = event.target.getAttribute('href');
            }
        }
    });
}